var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_1056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 27.3667V33.26C35.0002 33.682 34.8403 34.0883 34.5527 34.397C34.265 34.7057 33.8709 34.8938 33.45 34.9233C32.7217 34.9733 32.1267 35 31.6667 35C16.9383 35 5 23.0617 5 8.33333C5 7.87333 5.025 7.27833 5.07667 6.55C5.1062 6.12907 5.2943 5.73502 5.60301 5.44735C5.91171 5.15968 6.31804 4.99981 6.74 5H12.6333C12.8401 4.99979 13.0395 5.07643 13.1929 5.21503C13.3463 5.35364 13.4427 5.5443 13.4633 5.75C13.5017 6.13333 13.5367 6.43833 13.57 6.67C13.9012 8.98154 14.58 11.2297 15.5833 13.3383C15.7417 13.6717 15.6383 14.07 15.3383 14.2833L11.7417 16.8533C13.9408 21.9774 18.0242 26.0609 23.1483 28.26L25.715 24.67C25.8199 24.5233 25.973 24.4181 26.1475 24.3728C26.322 24.3274 26.5069 24.3447 26.67 24.4217C28.7784 25.4231 31.026 26.1002 33.3367 26.43C33.5683 26.4633 33.8733 26.5 34.2533 26.5367C34.4587 26.5577 34.649 26.6543 34.7873 26.8076C34.9255 26.961 35.0019 27.1602 35.0017 27.3667H35Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_1056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFill);
export default __webpack_public_path__ + "static/media/phone-fill.adc9e3285054fcbbab73ce595a8992c7.svg";
export { ForwardRef as ReactComponent };